import { useEffect } from 'react'

import { useSearchParams } from 'react-router-dom'

import { storeToken } from '../utils'

/**
 * Hook to extract token from URL and store it
 * Returns the token from URL if present
 */
export const useUrlToken = (): string | null => {
  const [searchParams, setSearchParams] = useSearchParams()
  const urlToken = searchParams.get('token')

  useEffect(() => {
    if (urlToken) {
      // Store token from URL
      storeToken(urlToken)

      // Clean URL by removing token parameter
      searchParams.delete('token')
      setSearchParams(searchParams)
    }
  }, [urlToken, searchParams, setSearchParams])

  return urlToken
}
